import { propertyDescriptions } from '@mcpanel/core';
import type { SearchEntry } from './types';

const names: Record<string, string> = {
  'view-distance': '描画距離',
  'simulation-distance': 'シミュレーション距離',
  'spawn-monsters': 'モンスターの自然発生',
  'spawn-animals': '動物の自然発生',
  'spawn-npcs': '村人の出現',
  'white-list': 'ホワイトリストの有効化',
  'enforce-whitelist': 'ホワイトリスト外の参加者を切断',
  'player-idle-timeout': '放置プレイヤーのタイムアウト',
  'force-gamemode': 'ゲームモードを強制',
  'op-permission-level': 'OP の権限レベル',
  'enable-command-block': 'コマンドブロック',
  'broadcast-console-to-ops': 'コマンド結果を OP に通知',
  'hide-online-players': 'オンラインの参加者名を隠す',
  'enforce-secure-profile': '署名付きプロフィールを必須にする',
  'max-tick-time': '処理停止の監視時間',
  'network-compression-threshold': '通信の圧縮',
  'entity-broadcast-range-percentage': 'エンティティの表示範囲',
  'sync-chunk-writes': 'チャンクの同期書き込み',
};
export const advancedGameIndex: SearchEntry[] = Object.entries(propertyDescriptions)
  .filter(([key]) => key !== 'allow-nether')
  .map(([key, description]) => ({
    id: `property-${key}`,
    name: names[key] ?? key,
    description,
    place: 'ゲーム設定 › サーバープロパティの詳細',
    keywords: `${key} ${key === 'white-list' || key === 'enforce-whitelist' ? 'whitelist ホワイトリスト 許可リスト' : ''} サーバープロパティ 詳細 ゲーム設定`,
    path: '/servers/:id',
    tab: 'settings',
    section: 'game-settings',
    focus: `property-${key}`,
  }));

const readOnlyProperties = [
  ['server-port', 'サーバーポート'],
  ['server-ip', 'サーバー IP'],
  ['online-mode', 'オンライン認証'],
  ['enable-rcon', 'RCON の有効化'],
  ['rcon.port', 'RCON ポート'],
  ['rcon.password', 'RCON の認証情報'],
  ['level-name', 'ワールド名'],
  ['enable-query', 'Query の有効化'],
  ['query.port', 'Query ポート'],
  ['generate-structures', '構造物の生成プロパティ'],
  ['level-seed', '生成済みワールドのシード'],
  ['level-type', 'ワールドの生成タイプ'],
  ['generator-settings', 'ワールドの生成設定プロパティ'],
];
export const readOnlyGameIndex: SearchEntry[] = readOnlyProperties.map(([key, name]) => ({
  id: `property-${key}`,
  name: `${name}（表示のみ）`,
  description: 'ゲーム設定 › サーバープロパティの詳細',
  keywords: `${key} server.properties パネル管理 読み取り専用`,
  path: '/servers/:id',
  tab: 'settings',
  section: 'game-settings',
  focus: `property-${key}`,
}));
